<template>
  <div>
    <div v-if="step === 'form'">
      <div class="form-group form__group" :class="{ 'is-invalid': errors.name }">
        <label class="form-label form__label">Имя</label>
        <input
          type="text"
          class="form-control form-control--white"
          :class="{ 'is-invalid': errors.name }"
          v-model="contact.name"
          placeholder="Александр"
        >
        <p class="invalid-feedback" v-if="errors.name">
          {{ Array.isArray(errors.name) ? errors.name.join(', ') : errors.name }}
        </p>
      </div>

      <div class="form-group form__group" :class="{ 'is-invalid': errors.contact }">
        <label class="form-label form__label">Телефон, Telegram или email</label>
        <input
          type="text"
          class="form-control form-control--white"
          :class="{ 'is-invalid': errors.contact }"
          v-model="contact.contact"
          placeholder="+7 930 283-02-35 или @tgName"
        >
        <p class="invalid-feedback" v-if="errors.contact">
          {{ Array.isArray(errors.contact) ? errors.contact.join(', ') : errors.contact }}
        </p>
      </div>

      <div class="form-group form__group" :class="{ 'is-invalid': errors.message }">
        <label class="form-label form__label">Опишите задачу и удобное время для связи</label>
        <textarea
          class="form-control form-control--white"
          rows="4"
          :class="{ 'is-invalid': errors.message }"
          v-model="contact.message"
          placeholder="Например: нужно разработать личный кабинет для дилеров с расчётом бонусов..."
        ></textarea>
        <p class="invalid-feedback" v-if="errors.message">
          {{ Array.isArray(errors.message) ? errors.message.join(', ') : errors.message }}
        </p>
      </div>

      <div class="form__actions">
        <button
          type="button"
          class="btn btn--secondary contact-form__submit w-100"
          @click="sendForm"
          :disabled="!contact.contact.trim()"
        >
          Отправить
          <i class="fas fa-arrow-right contact-form__submit-icon"></i>
        </button>
        <p class="form-accept__text text-center mt-2">
          Отправляя, вы принимаете
          <a href="/privacy/">условия</a>
          обработки персональных данных
        </p>
      </div>

      <!-- Общая ошибка -->
      <p class="text-danger mt-3" v-if="errors.detail">
        {{ errors.detail }}
      </p>
    </div>

    <div v-if="step === 'complete'" class="text-center">
      <div class="contact-form__success-icon">
        <i class="fas fa-check-circle"></i>
      </div>
      <p class="contact-form__success-text">
        Сообщение успешно отправлено!<br>
        Я свяжусь с вами в ближайшее время.
      </p>
      <button
        type="button"
        class="btn contact-form__submit contact-form__submit--outline mt-3"
        @click="resetForm"
      >
        Отправить ещё сообщение
      </button>
    </div>
  </div>
</template>

<script>
import FormApiMixin from '../../vue_mixins/FormApiMixin.js'

export default {
  name: 'ContactForm',

  props: {
    apiUrl: {
      type: String,
      default: '/contacts/api/request/'
    },
    metrikaJsId: {
      type: String,
      default: 'CONTACT_MESSAGE'
    }
  },

  setup(props) {
    const mixin = FormApiMixin(props)

    return {
      ...mixin
    }
  }
}
</script>

<style scoped>
.contact-form__success-icon {
  font-size: 48px;
  color: var(--bs-success, #198754);
  margin-bottom: 16px;
}

.contact-form__success-text {
  font-size: 17px;
  line-height: 1.6;
  color: #44474d;
  margin: 0;
}

.contact-form__submit--outline {
  background: transparent;
  border: 1.5px solid #c4c6cc;
  color: #171717;
}

.contact-form__submit--outline:hover {
  border-color: #171717;
}
</style>